import { START_LOADING, GET_VACATION_OVERVIEW, VACATION_RESET,STOP_LOADING, ERROR } from "../vacationOverviewAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_VACATION_OVERVIEW:
      return {
        ...state,
        vacation_overview: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case VACATION_RESET:
      return {
        ...state,
        vacation_overview: '',
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}